export default function townWarning(selector) {
  let hasTown = false;
  const currentTownName = selector.getValue() ? selector.getValue().label : "";
  const hasNoResult = document.querySelectorAll(".js-city-name").length === 0;
  document.querySelectorAll(".js-city-name").forEach((span) => {
    if (span.textContent === currentTownName) {
      hasTown = true;
    }
  });
  if (currentTownName !== "" && !hasTown && !hasNoResult) {
    document.getElementById("js-town-warning").classList.remove("hidden");
    document.getElementById("js-town-unreached").innerHTML = currentTownName;
  } else {
    document.getElementById("js-town-warning").classList.add("hidden");
    document.getElementById("js-town-unreached").innerHTML = "";
  }
}
